import React from "react";

import {
  Circle,
  Desc,
  Number,
  NumberBlock,
  Title,
  TitleBlock,
  TitleColored,
  WorkflowItem,
  WorkflowList,
  Wrapper,
} from "./styles"

type TWorkflowItem = {
  number: string,
  icon_color: string,
  title: string,
  colored_title: string,
  desc: string,
};

type TWorkflowSection = {
  data: TWorkflowItem[];
};

export const WorkflowSection: React.FC<TWorkflowSection> = ({ data }) => {
  return (
    <WorkflowList>
      {data.map((item, index) => (
        <WorkflowItem key={index}>
          <Wrapper>
            <NumberBlock>
              <Circle color={item.icon_color}/>
              <Number>{item.number}</Number>
            </NumberBlock>
            <TitleBlock>
              <Title>{item.title}</Title>
              <TitleColored>{item.colored_title}</TitleColored>
            </TitleBlock>
          </Wrapper>
          <Desc>{item.desc}</Desc>
        </WorkflowItem>
      ))}
    </WorkflowList>
  )
}
